import Vector from '../Math/Vector';
import AssetManager from '../AssetManager';

export class LibraryEntry {
    constructor(id) {
        this.id = id;
    }

    deserialize(data) {}
}

export class PrefabLibraryEntry extends LibraryEntry {
    constructor(id) {
        super(id);
        this.name = 'Geen naam';
        this.data = '';
        this.preview = '';
        this.previewHue = 0;
    }

    deserialize(data) {
        this.name = data.name;
        this.data = data.data;
        this.preview = data.preview;
        if (data.previewHue) this.previewHue = data.previewHue;
    }

    get() {
        return this.data;
    }
}

export class SoundLibraryEntry extends LibraryEntry {
    constructor(id) {
        super(id);
        this.name = 'Geen naam';
        this.asset = '';
    }

    deserialize(data) {
        this.name = data.name;
    }

    get() {
        return AssetManager.get(this.asset);
    }

    getAsset() {
        return AssetManager.retrieveLoaded(this.asset);
    }
}

export class TextureLibraryEntry extends LibraryEntry {
    constructor(id) {
        super(id);
        this.stretch = false;
        this.asset = '';
    }

    deserialize(data) {
        this.stretch = data.stretch;
    }

    get() {
        return AssetManager.get(this.asset);
    }

    getAsset() {
        return AssetManager.retrieveLoaded(this.asset);
    }
}

export class HatLibraryEntry extends LibraryEntry {
    constructor(id) {
        super(id);
        this.posSide = new Vector();
        this.posTop = new Vector();
        this.assetSide = '';
        this.assetTop = '';
    }

    deserialize(data) {
        this.posSide.x = data.side.x;
        this.posSide.y = data.side.y;
        this.posTop.x = data.top.x;
        this.posTop.y = data.top.y;
    }

    getSide() {
        return AssetManager.get(this.assetSide);
    }

    getTop() {
        return AssetManager.get(this.assetTop);
    }
}

export class LibraryCategory {
    constructor(library, title) {
        this.title = title;
        this.description = '';
        this._items = [];
        this._dictionary = {};
        this.libary = library;
    }

    getItems() {
        return this._items;
    }

    addItem(item) {
        if (this._dictionary[item.id]) throw new Error(`Entry in library with id "${item.id}" already exists`);
        this._items.push(item);
        this._dictionary[item.id] = item;
    }
}

export default class Library {
    constructor(title) {
        this.title = title;
        this._categories = [];
    }

    getCategory(index) {
        if (index < 0 || index >= this._categories.length) throw new Error("Can't find library category. Out of bounds index.");
        return this._categories[index];
    }

    getCategories() {
        return this._categories;
    }

    createCategory(title) {
        const newCategory = new LibraryCategory(this, title);
        this._categories.push(newCategory);
        return newCategory;
    }

    get(id) {
        for (let i = 0; i < this._categories.length; i++) {
            const category = this._categories[i];
            if (category._dictionary[id]) {
                return category._dictionary[id];
            }
        }
        throw new Error(`No item in this library matches id: "${id}".`);
    }
}
